import { configureStore } from '@reduxjs/toolkit';
import { loginSlice, User } from '../login/loginSlice';
import { localeSlice } from '../i18n/locale';
import { onboardingUiSlice } from '../pages/onboarding/state/onboardingUiSlice';
import { onboardingFilterSlice } from '../pages/onboarding/state/onboardingFilterSlice';
import {
  vehicleMiddleware,
  vehicleReducer,
  vehicleReducerPath,
} from './vehicles/vehiclesApiTemplateSlice';
import {
  transactionsMiddleware,
  transactionsReducer,
  transactionsReducerPath,
} from './transactions/transactionsApiTemplateSlice';
import { transactionFilterSlice } from './transactions/transactionFilterSlice';
import { transactionsUiSlice } from '../pages/transactions/state/transactionsUiSlice';
import {
  bookingsMiddleware,
  bookingsReducer,
  bookingsReducerPath,
} from './bookings/bookingsApiTemplateSlice';
import { bookingsFilterSlice } from './bookings/bookingsFilterSlice';
import { bookingsUiSlice } from '../pages/bookings/state/bookingsUiSlice';
import {
  locationsMiddleware,
  locationsReducer,
  locationsReducerPath,
} from './locations/locationsApiTemplateSlice';
import { paymentMethodUpdateSlice } from './vehicles/paymentMethodUpdateSlice';
import { supportDialogSlice } from './dialogs/useSupportDialog';
import { userManualDialogSlice } from './dialogs/useUserManualDialog';
import {
  paymentPartnerMiddleware,
  paymentPartnerReducer,
  paymentPartnerReducerPath,
} from './paymentPartners/paymentPartnersApiTemplateSlice';
import { bookingUpdateSlice } from './bookings/bookingsUpdateSlice';
import { tagsMiddleware, tagsReducer, tagsReducerPath } from './tags/tagsSlice';
import {
  assetsMiddleware,
  assetsReducer,
  assetsReducerPath,
} from './assets/assetsSlice';

export const createStore = (user: User) => {
  return configureStore({
    reducer: {
      locale: localeSlice.reducer,
      login: loginSlice(user).reducer,
      supportDialogState: supportDialogSlice.reducer,
      userManualDialogState: userManualDialogSlice.reducer,
      onboardingUiState: onboardingUiSlice.reducer,
      onboardingFilter: onboardingFilterSlice.reducer,
      transactionsUiState: transactionsUiSlice.reducer,
      transactionFilter: transactionFilterSlice.reducer,
      bookingsUiState: bookingsUiSlice.reducer,
      bookingsFilter: bookingsFilterSlice.reducer,
      bookingUpdate: bookingUpdateSlice.reducer,
      paymentMethodUpdate: paymentMethodUpdateSlice.reducer,
      [vehicleReducerPath]: vehicleReducer,
      [transactionsReducerPath]: transactionsReducer,
      [bookingsReducerPath]: bookingsReducer,
      [locationsReducerPath]: locationsReducer,
      [paymentPartnerReducerPath]: paymentPartnerReducer,
      [tagsReducerPath]: tagsReducer,
      [assetsReducerPath]: assetsReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        vehicleMiddleware,
        paymentPartnerMiddleware,
        transactionsMiddleware,
        bookingsMiddleware,
        locationsMiddleware,
        tagsMiddleware,
        assetsMiddleware,
      ),
  });
};

type Store = ReturnType<typeof createStore>;
export type RootState = ReturnType<Store['getState']>;
export type AppDispatch = Store['dispatch'];
